//@flow

import React from 'react';

import List, { ListItem, ListItemText } from 'material-ui/List';

import GroupIcon from '../../common/GroupIcon';
import Console from '../../../lib/debug';

const CALENDAR_SUBSCRIPTION_COLORS = {
    '1': '#ffbd01',
    '2': '#00bd76',
    '3': '#de350b'
};

type Props = {
    list: Array<CalendarTyping>, //required
    onSelect: (item: CalendarTyping) => void, //required
    onEnterItem: (item: CalendarTyping, ev: AnyEvent) => void //required
};

export default class CalendarDrawerList extends React.Component<Props> {
    getCalendarSubscriptionStyle(
        subscriptionCount: number
    ): { backgroundColor?: string } {
        let subscriptionCountColor =
            CALENDAR_SUBSCRIPTION_COLORS[subscriptionCount];
        return subscriptionCountColor
            ? { backgroundColor: subscriptionCountColor }
            : {};
    }

    render(): React.DOM {
        Console.render('CalendarDrawerList');

        let listItems = [];
        let itemCount = this.props.list.length;
        let items = this.props.list;
        for (let i = 0; i < itemCount; i++) {
            let subscribed = items[i].subscribed ? 'Subscribed' : null;
            let style = this.getCalendarSubscriptionStyle(items[i].subCount);
            listItems.push(
                <ListItem
                    button
                    onClick={() => this.props.onSelect(items[i])}
                    key={`${items[i].typeElement}-${items[i].id}`}
                    onMouseOver={(ev: AnyEvent) =>
                        this.props.onEnterItem(items[i], ev.currentTarget)
                    }
                    onFocus={(ev: AnyEvent) =>
                        this.props.onEnterItem(items[i], ev.currentTarget)
                    }
                    // onMouseOut={this.props.onLeaveItem}
                    className="calendar-drawer-item"
                    style={style}
                >
                    <GroupIcon src={items[i].logo || items[i].icon} />
                    <ListItemText
                        primary={items[i].title}
                        secondary={subscribed}
                    />
                </ListItem>
            );
        }

        return <List>{listItems}</List>;
    }
}
